export enum GaButtonSection {
  Header = 'Header',
}
